import { hasFieldChangedValue } from '../../Helpers/FormInputHelper';

export const areFieldsValid = editedSplitData => {
  if (!editedSplitData.coAgentCode) {
    return false;
  }

  if (!editedSplitData.share) {
    return false;
  }

  return true;
};

export const getChangedFieldsForSplitData = (editedSplitData, splitData) => {
  let sum = 0;
  if (hasFieldChangedValue(editedSplitData?.share, splitData.share)) {
    sum = sum + 1;
  }

  return sum;
};
